<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="DC编号" prop="dcCode">
                <el-input v-model="queryCondition.dcCode" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DC名称" prop="dcName">
                <el-input v-model="queryCondition.dcName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select clearable table="TM_QSPI_DC" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row" v-if="ms_roles.indexOf('QSPI_MASTER_ADMIN')!==-1">
        <el-button size="mini" class="btn" type="primary" @click="onActive" v-acl="QSPI_DC_SAVE">启用</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onDisable" v-acl="QSPI_DC_SAVE">禁用</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onCreate" v-acl="QSPI_DC_GEN_TASK">生成评分任务</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="QSPI_DC_DEL_TASK">删除评分任务</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="DC编号" field="dcCode"></ux-table-column>
        <ux-table-column align="center" title="DC名称" field="dcName"></ux-table-column>
        <ux-table-column align="center" title="状态" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="更新人" field="updateUser"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index';
import QspiConfigApi from "@/api/qspiConfig/index";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      dcIds: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        dcNo: "",
        dcName: "",
        status: ""
      },
      totalCount: 0,
      pages: 1,
      ms_roles: null,
    }
  },
  created() {
    this.queryData();
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    console.log('ms_roles', this.ms_roles);
  },
  methods: {
    queryData() {
      QspiConfigApi.getQspiDcList(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.$refs.plxTable.reloadData(res.resultData)
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        dcNo: "",
        dcName: "",
        status: ""
      }
      this.dcIds = []
      this.queryData();
    },
    // 选中的行
    selectionChange(row) {
      this.dcIds = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.dcIds.push(ele.tmQspiDcId)
      });
    },
    onCreate() {
      if (this.dcIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'ACTIVE'
      })
      if (!flag) {
        this.$message.error('只有启用的DC可以生成评分任务')
        return
      }
      QspiConfigApi.generateScore({ dcIds: this.dcIds }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('生成评分成功')
          this.dcIds = []
          this.queryData();
        }
      });
    },
    onDel() {
      console.log('this.dcIds', this.dcIds);
      if (this.dcIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'INACTIVE'
      })
      if (!flag) {
        this.$message.error('只有禁用的DC可以删除评分任务')
        return
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        QspiConfigApi.deleteScore({ dcIds: this.dcIds }).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$message.success('删除评分成功')
            this.dcIds = []
            this.queryData();
          }
        });
      })
    },
    onActive() {
      if (this.dcIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'INACTIVE'
      })
      if (!flag) {
        this.$message.error('只有禁用的DC可以启用')
        return
      }
      QspiConfigApi.changeQspiDcToActive({ dcIds: this.dcIds }).then(res => {
        console.log('555', res);
        if (res.code == '200') {
          this.$message.success('启用成功')
          this.dcIds = []
          this.queryData();
        }
      });
    },
    onDisable() {
      if (this.dcIds.length === 0) {
        this.$message.error('请先选择数据后再操作')
        return
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'ACTIVE'
      })
      if (!flag) {
        this.$message.error('只有启用的DC可以禁用')
        return
      }
      QspiConfigApi.changeQspiDcToInactive({ dcIds: this.dcIds }).then(res => {
        console.log('777', res);
        this.$message.success('禁用成功')
        this.dcIds = []
        this.queryData();
      });
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
